export function appCreateNotify(appId){
    return {type:'APP_CREATE_NOTIFY', payload: {appId}};
}

export function appInfoSet(appInfo){
    return {type:'APP_INFO', payload: {data: appInfo}};
}